// Accepts item (string) and data (JSON)
export const setLocalStorageItem: (item: string, data: any) => void = (
  item: string,
  data: any
) => {
  localStorage.setItem(
    item,
    typeof data === "object" ? JSON.stringify(data) : data
  );
};

// Accepts item (string) and returns JSON data
export const getLocalStorageItem: (item: string) => any = (item: string) => {
  const receivedItem: string = localStorage.getItem(item) ?? "";

  try {
    return JSON.parse(receivedItem);
  } catch (e) {
    return receivedItem;
  }
};
